// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  position: absolute;
  z-index: 20
}

/* TOOLTIP WORKAROUND FOR ARROW UP */

.tooltip.tooltip-bottom .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  content: '';
  width: 14px;
  height: 1px;
  top: -1px;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%)
}

.tooltip.tooltip-top .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  content: '';
  width: 14px;
  height: 1px;
  bottom: -1px;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%)
}

.tooltip.tooltip-bottom {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%)
}

.tooltip.tooltip-top {
  margin-bottom: 0.25rem;
  padding-bottom: 0.5rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  bottom: 100%
}

.tooltip.tooltip-bottom-left {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  left: 0
}

.tooltip.tooltip-bottom-right {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  right: 0
}

.tooltip.tooltip-left {
  margin-right: 1rem;
  top: 50%;
  right: calc(100%);
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-right {
  margin-left: 1rem;
  top: 50%;
  left: calc(100%);
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-right .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  content: '';
  width: 2px;
  height: 15px;
  left: -1px;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-left .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  content: '';
  width: 2px;
  height: 15px;
  right: -1px;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-bottom-right .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  content: '';
  width: 15px;
  height: 2px;
  right: 5px;
  top: -1px
}

.tooltip.tooltip-bottom-left .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  content: '';
  width: 15px;
  height: 2px;
  left: 5px;
  top: -1px
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/Tooltip/tooltip.css"],"names":[],"mappings":"AACE;EAAA,kBAAoB;EAApB;AAAoB;;AAGtB,oCAAoC;;AAElC;EAAA,kBAA6B;EAA7B,WAA6B;EAA7B,kBAA6B;EAA7B,yDAA6B;EAC7B,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,SAAS;EACT,mCAA2B;UAA3B;AAN6B;;AAU7B;EAAA,kBAA6B;EAA7B,WAA6B;EAA7B,kBAA6B;EAA7B,yDAA6B;EAC7B,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mCAA2B;UAA3B;AAN6B;;AAU7B;EAAA,mBAAgB;EAAhB,mBAAgB;EAChB,SAAS;EACT,mCAA2B;UAA3B;AAFgB;;AAMhB;EAAA,sBAAgB;EAAhB,sBAAgB;EAChB,SAAS;EACT,mCAA2B;UAA3B,2BAA2B;EAC3B;AAHgB;;AAOhB;EAAA,mBAAgB;EAAhB,mBAAgB;EAChB;AADgB;;AAKhB;EAAA,mBAAgB;EAAhB,mBAAgB;EAChB;AADgB;;AAKhB;EAAA,kBAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,mCAA2B;UAA3B;AAHW;;AAOX;EAAA,iBAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,mCAA2B;UAA3B;AAHW;;AAOX;EAAA,kBAA6B;EAA7B,WAA6B;EAA7B,kBAA6B;EAA7B,yDAA6B;EAC7B,WAAW;EACX,UAAU;EACV,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,mCAA2B;UAA3B;AAN6B;;AAU7B;EAAA,kBAA6B;EAA7B,WAA6B;EAA7B,kBAA6B;EAA7B,yDAA6B;EAC7B,WAAW;EACX,UAAU;EACV,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,mCAA2B;UAA3B;AAN6B;;AAU7B;EAAA,kBAA6B;EAA7B,WAA6B;EAA7B,kBAA6B;EAA7B,yDAA6B;EAC7B,WAAW;EACX,WAAW;EACX,WAAW;EACX,UAAU;EACV;AAL6B;;AAS7B;EAAA,kBAA6B;EAA7B,WAA6B;EAA7B,kBAA6B;EAA7B,yDAA6B;EAC7B,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT;AAL6B","sourcesContent":[".tooltip {\n  @apply absolute z-20;\n}\n\n/* TOOLTIP WORKAROUND FOR ARROW UP */\n.tooltip.tooltip-bottom .tooltip-box::before {\n  @apply bg-white absolute z-10;\n  content: '';\n  width: 14px;\n  height: 1px;\n  top: -1px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.tooltip.tooltip-top .tooltip-box::before {\n  @apply bg-white absolute z-10;\n  content: '';\n  width: 14px;\n  height: 1px;\n  bottom: -1px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.tooltip.tooltip-bottom {\n  @apply mt-1 pt-2;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.tooltip.tooltip-top {\n  @apply mb-1 pb-2;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 100%;\n}\n\n.tooltip.tooltip-bottom-left {\n  @apply mt-1 pt-2;\n  left: 0;\n}\n\n.tooltip.tooltip-bottom-right {\n  @apply mt-1 pt-2;\n  right: 0;\n}\n\n.tooltip.tooltip-left {\n  @apply mr-4;\n  top: 50%;\n  right: calc(100%);\n  transform: translateY(-50%);\n}\n\n.tooltip.tooltip-right {\n  @apply ml-4;\n  top: 50%;\n  left: calc(100%);\n  transform: translateY(-50%);\n}\n\n.tooltip.tooltip-right .tooltip-box::before {\n  @apply bg-white absolute z-10;\n  content: '';\n  width: 2px;\n  height: 15px;\n  left: -1px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.tooltip.tooltip-left .tooltip-box::before {\n  @apply bg-white absolute z-10;\n  content: '';\n  width: 2px;\n  height: 15px;\n  right: -1px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.tooltip.tooltip-bottom-right .tooltip-box::before {\n  @apply bg-white absolute z-10;\n  content: '';\n  width: 15px;\n  height: 2px;\n  right: 5px;\n  top: -1px;\n}\n\n.tooltip.tooltip-bottom-left .tooltip-box::before {\n  @apply bg-white absolute z-10;\n  content: '';\n  width: 15px;\n  height: 2px;\n  left: 5px;\n  top: -1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
